// action - state management
import * as actionTypes from './actions';

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

export const initialState = {
  isOpen: 'insights', //for active default menu
  navType: '',
  currentDate: new Date(),
  selectedZone: 'all',
  isExpanded: false, // for sidebar expansion state
  selectedTime: {
    start_time: new Date().setHours(10, 0, 0, 0),
    end_time: new Date().setHours(22, 0, 0, 0)
  }
};

const customizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.MENU_OPEN:
      return {
        ...state,
        isOpen: action.isOpen
      };
    case actionTypes.MENU_TYPE:
      return {
        ...state,
        navType: action.navType
      };
    case actionTypes.CURRENT_DATE:
      return {
        ...state,
        currentDate: action.currentDate
      };
    case actionTypes.SET_SELECTED_ZONES:
      return {
        ...state,
        selectedZone: action.selectedZone
      };
    case actionTypes.SELECTED_TIME:
      return {
        ...state,
        selectedTime: action.selectedTime
      };
    case actionTypes.SIDEBAR_STATE:
      return {
        ...state,
        isExpanded: action.isExpanded
      };
    default:
      return state;
  }
};

export default customizationReducer;
